<template>
    <div
        class="pichi-tunnel-ball-list"
        :class="{ opened: opened }"
    >
        <div class="listBody">
            <!-- 比較モード -->
            <div class="listWrapper">
                <v-touch
                    tag="div"
                    class="filter"
                    @pinch="invalidPinch($event)"
                >
                    <p><span>【投球2】</span></p>
                    <!-- PT2遷移 -->
                    <!-- <v-touch tag="p" class="openSearchBtn" @tap="movePT2Search" v-if="savedBalls.length !== 0">
                      <span class="icon-search"></span>
                    </v-touch> -->
                </v-touch>

                <!-- 比較球リスト -->
                <div class="balls_compare">
                    <div
                        v-if="savedBalls.length === 0"
                        class="noSavedBalls"
                    >
                        <p class="text">
                            投球2を設定してください
                        </p>
                    </div>

                    <div v-else>
                        <div
                            v-if="sortMode === 0"
                            class="ballWrapper"
                        >
                            <div class="pitcher">
                                <p
                                    class="team"
                                    :class="{styleLongName: savedBalls[0].team.name.length > 9}"
                                >
                                    {{
                                        savedBalls[0].team.name
                                    }}
                                </p>
                                <p class="player">
                                    <span
                                        class="no"
                                    >{{ savedBalls[0].pitcher.uniform_number }}</span>&nbsp;&nbsp;&nbsp;<span
                                        class="name"
                                    >{{ savedBalls[0].pitcher.name }}</span>
                                </p>
                            </div>

                            <div
                                v-for="(d, index) in savedBalls"
                                :key="'savedBalls'+index"
                                class="ball"
                                :class="{'notPT': !d.ptFlag}"
                            >
                                <table class="ballInfo">
                                    <tr>
                                        <td class="item">
                                            試合日
                                        </td>
                                        <td class="value">
                                            {{ $d(d.data.timestamp).format("YYYY/MM/DD") }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="item">
                                            球種
                                        </td>
                                        <td class="value">
                                            {{ setting.typesOfBall[d.data.pitchingdata.TaggedPitchType].name }}
                                        </td>
                                    </tr>
                                </table>
                                <div class="expand">
                                    <table class="ballInfo">
                                        <tr>
                                            <td class="item">
                                                速度
                                            </td>
                                            <td class="value">
                                                {{
                                                    (d.data.pitchingdata.RelSpeed / 1000)?.toFixed(1) ?? ''
                                                }}km/h
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="item">
                                                回転速度
                                            </td>
                                            <td class="value">
                                                {{
                                                    d.data.pitchingdata.SpinRate?.toFixed(1) ?? ''
                                                }}rpm
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="item">
                                                α
                                            </td>
                                            <td class="value">
                                                {{
                                                    d.data.pitchingdata.Rifle?.toFixed(1) ?? ''
                                                }}°
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="item">
                                                速度割合
                                            </td>
                                            <td class="value">
                                                {{ d.data.pitchingdata?.avgSpeed ?? '' }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="item">
                                                変化量縦
                                            </td>
                                            <td class="value">
                                                {{ (Math.round(d.data.pitchingdata.InducedVertBreak * 1000) / 10) }}cm
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="item">
                                                変化量横
                                            </td>
                                            <td class="value">
                                                {{ (Math.round(d.data.pitchingdata.HorzBreak * 1000) / 10) }}cm
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="item">
                                                奥行
                                            </td>
                                            <td class="value">
                                                {{ (Math.round(d.data.pitchingdata.Depth * 1000) / 10) }}cm
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="item">
                                                リリース高
                                            </td>
                                            <td class="value">
                                                {{ (Math.round(d.data.pitchingdata.RelHeight * 1000) / 10) }}cm
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="item">
                                                リリース横
                                            </td>
                                            <td class="value">
                                                {{ (Math.round(d.data.pitchingdata.RelSide * 1000) / 10) }}cm
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="item">
                                                エクステンション
                                            </td>
                                            <td class="value">
                                                {{ (Math.round(d.data.pitchingdata.Extension * 1000) / 10) }}cm
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="icons">
                                    <v-touch
                                        v-if="d.compareExist"
                                        tag="button"
                                        class="add-compare done"
                                        @tap="deleteBall(d.data.id)"
                                    >
                                        済
                                    </v-touch>
                                    <v-touch
                                        v-else
                                        tag="button"
                                        class="add-compare"
                                        @tap="addBall(index)"
                                    >
                                        比較
                                    </v-touch>


                                    <label>
                                        <input
                                            v-if="d.ptFlag"
                                            class="pt-check checked"
                                            checked="checked"
                                            value="PT"
                                            type="checkbox"
                                            @change="setSavedBallPTFlag(index)"
                                        >
                                        <input
                                            v-else
                                            class="pt-check"
                                            value="PT"
                                            type="checkbox"
                                            @change="setSavedBallPTFlag(index)"
                                        >
                                        <span class="pt-check-name">PT</span>
                                    </label>

                                    <svg
                                        width="20"
                                        height="20"
                                        class="ballColor"
                                    >
                                        <v-touch
                                            tag="circle"
                                            cx="10"
                                            cy="11"
                                            r="6"
                                            :fill="d.ballColor"
                                        />
                                    </svg>
                                    <v-touch
                                        v-if="d.enabled"
                                        tag="span"
                                        class="icon-view view enable"
                                        @tap="toggleSavedBall(false, index)"
                                    />
                                    <v-touch
                                        v-else
                                        tag="span"
                                        class="icon-view view disable"
                                        @tap="toggleSavedBall(true, index)"
                                    />
                                    <v-touch
                                        tag="span"
                                        class="icon-arrow-up arrow arrowClose"
                                        @tap="close($event)"
                                    />
                                    <v-touch
                                        tag="span"
                                        class="icon-arrow-down arrow arrowOpen"
                                        @tap="open($event)"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="opener">
                <v-touch
                    v-if="opened"
                    tag="p"
                    class="icon-arrow-left"
                    @tap="opened = false"
                />
                <v-touch
                    v-else
                    tag="p"
                    class="icon-arrow-right"
                    @tap="opened = true"
                />
            </div>
        </div>
    </div>
</template>

<script>
import setting from '@/setting.js'
import common from '@/common.js'

export default {
    name: "PichiTunnelBallInfoLists",
    props: ['mode', 'atBatBalls', 'allBalls', 'playing', 'nowID', 'colors', 'savedBalls', 'enableMultiPos', 'baseBallIndex', 'getBallText'],
    emits: ['single-pitch', 'edit-multi-positions', 'remove-saved-ball', 'change-base-ball', 'set-pichi-tunnel-saved-ball', 'compare-exist-check', 'delete-ball', 'set-saved-ball-ptflag', 'move-pt-2-search', 'toggle-saved-ball'],
    data() {
        return {
            setting,
            temp_kinds: [
                'ストレート',
                'カーブ',
                'ストレート',
                'スライダー',
                'チェンジアップ'
            ],
            opened: true,
            priority: [
                'Fastball',
                'ChangeUp',
                'Curveball',
                'Cutter',
                'KnuckleBall',
                'Sinker',
                'Slider',
                'Splitter'
            ],
            sortedArray: {
                'Fastball': [],
                'ChangeUp': [],
                'Curveball': [],
                'Cutter': [],
                'KnuckleBall': [],
                'Sinker': [],
                'Slider': [],
                'Splitter': []
            },
            pitchTypeName: {
                'Fastball': '速球',
                'ChangeUp': 'チェンジアップ',
                'Curveball': 'カーブ',
                'Cutter': 'カットボール',
                'KnuckleBall': 'ナックル',
                'Sinker': 'シンカー',
                'Slider': 'スライダー',
                'Splitter': 'スプリッター'
            },
            sortMode: 0,
            filterListFlg: false
        }
    },
    mounted() {
        this.sortArray(this.savedBalls)
    },
    methods: {
        singlePitch (index) {
            this.$emit('single-pitch', index)
        },
        open(event) {
            const ballElement = event.target.closest('.ball')
            ballElement.classList.add('open')
            const expandElement = ballElement.querySelector('.expand')
            expandElement.style.maxHeight = '300px'
            expandElement.querySelector('.ballInfo').style.display = 'block'
        },
        close(event) {
            const ballElement = event.target.closest('.ball')
            ballElement.classList.remove('open')
            const expandElement = ballElement.querySelector('.expand')
            expandElement.style.maxHeight = '0'
            expandElement.querySelector('.ballInfo').style.display = 'none'
        },
        enable(event) {
            const ballElement = event.target.closest('.ball')
            const isChecked = ballElement.querySelector('.icons .chkbx').checked
            if (isChecked) {
                ballElement.classList.add('added')
            } else {
                ballElement.classList.remove('added')
            }
        },
        editMultiPositions (id, event) {
            this.enable(event)
            this.$emit('edit-multi-positions', id, event)
        },
        removeSavedBall (index) {
            this.$emit('remove-saved-ball', index)
        },
        changeBaseBall (index) {
            this.$emit('change-base-ball', index)
        },
        toggleSavedBall (bool, index) {
            this.$emit('toggle-saved-ball', bool, index)
        },
        getResultText: function (result, hit) {
            console.log('getResultText')
            let text = ''
            if (result === 'Undefined' && hit === 'Undefined') {
                return '-'
            }
            if (result === 'InPlay') {
                text = this.setting.typesOfResult['InPlay'][hit].name
            } else {
                if (this.setting.typesOfResult[result] !== undefined) {
                    text = this.setting.typesOfResult[result].name
                } else {
                    text = result
                }
            }
            return text
        },
        sortArray (data) {
            this.sortedArray = {
                'Fastball': [],
                'ChangeUp': [],
                'Curveball': [],
                'Cutter': [],
                'KnuckleBall': [],
                'Sinker': [],
                'Slider': [],
                'Splitter': []
            }
            if (data && Array.isArray(data) && data.length > 0) {
                data.forEach((d, i) => {
                    d['defaultNum'] = i
                    this.sortedArray[d.data.pitchingdata.TaggedPitchType].push(d)
                })
            }
            this.$forceUpdate()
        },
        invalidPinch (e) {
            e.preventDefault()
        },
        setSavedBallPTFlag (index) {
            console.log('setSavedBallPTFlag,' + index + '　' + !this.savedBalls[index].ptFlag)
            this.$emit('set-saved-ball-ptflag', index, !this.savedBalls[index].ptFlag)
            if (this.savedBalls[index].ptFlag) {
                common.LOG('INFO', '3D軌跡 ピッチトンネル トップ', '投球2 PT計算対象追加', this.savedBalls[index].id)
            } else {
                common.LOG('INFO', '3D軌跡 ピッチトンネル トップ', '投球2 PT計算対象削除', this.savedBalls[index].id)
            }
        },
        deleteBall (id) {
            this.$emit('delete-ball', id, 'savedBalls')
            this.$alert('比較モードの比較球一覧から削除しました')
            this.$emit('compare-exist-check')
            this.$emit('set-pichi-tunnel-saved-ball')
            common.LOG('INFO', '3D軌跡 ピッチトンネル トップ', '投球2 比較球削除', id)
        },
        addBall (index) {
            const saveBalls = this.$ls.get('savedBalls',[])
            if (saveBalls.length >= 20) {
                this.$alert('比較球が20球登録されています')
                return
            }
            saveBalls.push(this.savedBalls[index])
            this.$ls.set('savedBalls', saveBalls)
            this.$alert('比較モードの比較球一覧に追加しました')
            this.$emit('compare-exist-check')
            this.$emit('set-pichi-tunnel-saved-ball')
            common.LOG('INFO', '3D軌跡 ピッチトンネル トップ', '投球2 比較球追加', this.savedBalls[index].id)
        }
    }
}
</script>

<style scoped>
.pichi-tunnel-ball-list {
    position: absolute;
    top: 45px;
    transition: .2s;
    left: -250px;
    z-index: 2;
    height: calc(97% - 50px);
}

.pichi-tunnel-ball-list.opened {
    left: 0;
}

.listBody {
    background: rgba(34, 34, 34, 0.85);
    width: 250px;
    /*  height: 723px;*/
    /*  height: calc(100vh - 45px);*/
    height: 100%;
    color: #fff;
    overflow: hidden;
}

.listWrapper {
    width: 250px;
    /*height: calc(100vh -45px);*/
    height: 100%;
    overflow: hidden;
}

.pitcher {
    padding: 12px 15px 2px;
    font-size: 13px;
}

.pitcher .team,
.pitcher .player {
    margin: 8px 0;
}

.balls_compare {
    height: calc(100% - 25px);
    padding-top: 10px;
    padding-bottom: 10px;
    box-sizing: border-box;
}

.balls_compare .pitcher {
    padding: 0 0 0 10px;
    margin: 0 0 10px;
}

.balls_compare .pitcher .team,
.balls_compare .pitcher .player {
    margin: 0;
}

.balls_compare .pitcher .team.styleLongName {
    transform-origin: top left;
    transform: scale(0.8, 1);
    width: 240px;
}

.balls_compare .pitcher .player {
    margin-top: 8px;
}

.balls_atBat,
.balls_compare {
    margin: 10px;
    overflow: auto;
}

.ball {
    font-size: 12px;
    background: rgba(51, 51, 51, 0.95);
    line-height: 12px;
    margin: 10px 0;
    padding: 10px 10px 50px 10px;
    position: relative;
    color: rgba(255, 255, 255, 0.35);
    /*cursor: pointer;
		user-select: none;
		-moz-user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;*/
}

.balls_compare .ball.notPT {
    opacity: 0.5;
    background: rgba(51, 51, 51, 0.6);
}

.balls_atBat .ball {
    padding: 10px;
}

.ball:nth-child(1) {
    margin-top: 0;
}

.balls_compare .ball,
.ball.now {
    color: rgba(255, 255, 255, 1);
}

.ballBlock:nth-child(1) .pitchTypeName {
    margin-top: 5px;
}

.ball .ballInfo {
    font-size: 12px;
    width: 100%;
}

.ball .expand {
    transition: .2s;
    max-height: 0;
}

.ball .expand .ballInfo {
    margin-top: 0;
    display: none;
}

.ball .ballInfo td {
    padding: 3px 0;
}

.ball .ballInfo td.item {
    padding-right: 10px;
}

.ballColor {
    margin: 0 8px;
    vertical-align: text-bottom;
}

.view.enable {
    font-size: 20px;
    color: rgba(255, 255, 255, 1);
}

.view.disable {
    font-size: 20px;
    color: rgba(255, 255, 255, 0.35);
}

.arrow {
    font-size: 20px;
}

.icons {
    position: absolute;
    bottom: 10px;
    width: 230px;
    height: 24px;
}

.filter {
    height: 45px;
    background: rgba(51, 51, 51, 0.95);
    position: relative;
    padding: 12px 15px;
    display: flex;
    cursor: pointer;
}

.filterBtn p span {
    width: auto;
    height: 20px;
    float: left;
    padding-top: 2px;
}

.filterBtn p span.icon-arrow-down {
    width: 20px;
    height: 20px;
    margin: 0 5px;
    padding-top: 0;
    font-size: 20px;
    float: right;
    color: #bbb;
}

.openSearchBtn {
    width: 25px;
    height: 25px;
    position: absolute;
    top: 10px;
    right: 20px;
    cursor: pointer;
}

.openSearchBtn span {
    padding: 10px;
    font-size: 25px;
}

.filterList {
    width: 220px;
    height: 45px;
    background: rgba(85, 85, 85, 0.95);
    position: absolute;
    padding: 12px 10px;
    display: flex;
    margin: 0 5px;
    top: 45px;
    left: 0;
    z-index: 2;
    cursor: pointer;
}

.ball .view {
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.ball .arrowClose {
    display: none;
    color: #bbb;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.ball.open .arrowClose {
    display: inline;
    padding-right: 0;
}

.ball .arrowOpen {
    display: inline;
    color: #bbb;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.ball.open .arrowOpen {
    display: none;
}

[type="checkbox"] {
    border: solid 1px #999;
    background-color: #fff;
    width: 12px;
    height: 12px;
}

[type="checkbox"]:checked {
    opacity: 1;
    background: #ff0000;
}

.opener {
    position: absolute;
    top: 50px;
    right: -20px;
    width: 20px;
    height: 35px;
    background: rgba(34, 34, 34, 0.85);
}

.opener .icon-arrow-left,
.opener .icon-arrow-right {
    font-size: 20px;
    line-height: 35px;
    color: #bbb;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.item {
    width: 9em;
}

.noSavedBalls {
    margin: 20px 10px;
}

.noAtBatBalls {
    margin: 20px 10px;
}

.noAtBatBalls .link {
    display: block;
    color: #fff;
    font-size: 12px;
    margin-top: 10px;
    border: solid 1px #fff;
    line-height: 23px;
    text-align: center;
}

.ballWrapper {
    width: 230px;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 10px;
}

.platform-ipad .ball:last-child,
.platform-ipad .ballBlock:last-child {
    margin-bottom: 20px;
}

.tab704 .ballWrapper > .ball:last-child,
.tab704 .ballWrapper > .ballBlock:last-child {
    margin-bottom: 45px;
}

.tab672 .ballWrapper > .ball:last-child,
.tab672 .ballWrapper > .ballBlock:last-child {
    margin-bottom: 80px;
}

button {
    background: #666;
    width: 50px;
    border: none;
    color: #fff;
    height: 25px;
    margin-right: 5px;
    outline: none;
}

.done {
    border: 1px solid #fff;
    background: #333;
}

.enable,
.disable {
    vertical-align: text-bottom;
    padding-right: 10px;
}

.arrowOpen,
.arrowClose {
    vertical-align: text-bottom;
}

.pt-check {
    display: none;
}

.pt-check-name {
    padding-left: 27px;
    position: relative;
}

.pt-check-name::before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 1px;
    width: 20px;
    height: 20px;
    background-color: #555555;
    border-radius: 4px;
}

.checked + .pt-check-name {
    color: #ffffff;
}

.checked + .pt-check-name::after {
    content: "";
    display: block;
    position: absolute;
    top: 2px;
    left: 7px;
    width: 4px;
    height: 10px;
    transform: rotate(40deg);
    border-bottom: 4px solid #ffffff;
    border-right: 4px solid #ffffff;
}

</style>
